function waitForElement(selector , timeout = 10000) {
  return new Promise(function(resolve, reject) {
    const interval = 1000; // ms
    const start = Date.now();

    const timer = setInterval(function() {
      let el = document.querySelector(selector);
      if (el) {
        clearInterval(timer);
        resolve(el);
      } else if (Date.now() - start > timeout) {
        clearInterval(timer);
        reject(new Error('Timed out waiting for ' + selector));
      }
    }, interval);
  });
}

async function waitForElements(selector , timeout = 10000) {
  return new Promise(function(resolve, reject) {
    const interval = 1000; // ms
    const start = Date.now();

    const timer = setInterval(function() {
      let el = document.querySelectorAll(selector);
      if (el) {
        clearInterval(timer);
        resolve(el);
      } else if (Date.now() - start > timeout) {
        clearInterval(timer);
        reject(new Error('Timed out waiting for ' + selector));
      }
    }, interval);
  });
}


// document.addEventListener("DOMContentLoaded", (event) => {
//   if(!document.querySelector('.template-product')) return;
//   let items = [],
//       index,
//       container = document.querySelector('section.product-section');
//   // Create a new click event
//   const galleryImageModal = new MouseEvent('click', {
//     view: window,
//     bubbles: true,
//     cancelable: true,
//   });

//   let productGallery = document.getElementById('Product-Slider');
//   let productGalleryFlickity = window.productGalleryFlickity || new Flickity(productGallery);

//   //if(!container) return;
//   let pswpContainer = container.querySelectorAll('.pswp')[0];
//   let pswp = window.productPSWP;
//   if (pswp) {
//     pswpContainer.listen('destroy', function() {
//       // if(pswpContainer.classList.contains('pswp--visible') && pswpContainer.querySelector('.pswp__button.pswp__counter').innerHTML != "") {
//       itemCounterHTML = pswpContainer.querySelector('.pswp__button.pswp__counter').innerHTML;
//       itemArray = itemCounterHTML.split('/');
//       //currentIndex = parseInt(itemArray[0].trim()) - 1;
//       currentIndex = parseInt(itemArray[0].trim()) ;
//       productGalleryFlickity.select(parseInt(currentIndex), false, false);
//     });
//   }


//   const pswpJustClosed = observeInnerHTMLChanges(pswpContainer, () => {
//     let itemCounter,
//         itemCounterHTML,
//         itemArray,
//         currentIndex;

//     // if(pswpContainer.classList.contains('pswp--visible') && pswpContainer.querySelector('.pswp__button.pswp__counter').innerHTML != "") {
//     itemCounterHTML = pswpContainer.querySelector('.pswp__button.pswp__counter').innerHTML;
//     itemArray = itemCounterHTML.split('/');
//     //currentIndex = parseInt(itemArray[0].trim()) - 1;
//     currentIndex = parseInt(itemArray[0].trim()) ;
//     productGalleryFlickity.select(parseInt(currentIndex), false, false);
//   });

//   function observeInnerHTMLChanges(element, callback) {
//     const observer = new MutationObserver(mutationsList => {
//       for (const mutation of mutationsList) {
//         if (mutation.type === 'childList' || mutation.type === 'characterData') {
//           callback();
//           break;
//         }
//       }
//     });

//     observer.observe(element, {
//       childList: true,
//       subtree: true,
//       characterData: true
//     });
//     return observer;
//   }

  //flkty.append(productGallery.querySelector('.no-variant--image'));
  //verticalCenterSliderThumbnail();

  //addIdToRecentlyViewed(document.querySelector('[data-handle]').dataset.handle);

  //SET FLICKITY VIEWPORTS HEIGHT AS VIDEO HEIGHT
  // let flickityProductSlider = document.getElementById('Product-Slider');
  // let viewPortHeight = flickityProductSlider.querySelector('.flickity-viewport').getBoundingClientRect().height + 'px';
  // flickityProductSlider.querySelector('.flickity-viewport').style.setProperty('--flickity-viewport-height', viewPortHeight);

  //WHOLE IMAGE TRIGGERS/OPENS MODAL
  // productGalleryFlickity.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {
  //   cellElement.querySelector('.product-single__media-zoom').click();
  // });
  // document.addEventListener("product:variant-change", function (evt) {
  //   const flkty = new Flickity(flickityProductSlider);
  //   flkty.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {
  //     cellElement.querySelector('.product-single__media-zoom').click();
  //   });
  // });
//});




function verticalCenterSliderThumbnail() {
  let thumbnailsContainer = document.getElementById('Product-Thumbnails');
  let thumbnails = thumbnailsContainer.querySelectorAll('.is-initial-selected');
  let active_thumb = thumbnails[0];

  if(!active_thumb) return;

  requestAnimationFrame(() => {
    //console.log(active_thumb.offsetParent);
    if (active_thumb.offsetParent === null) return;

    const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
    windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
    active_thumb.parentElement.scrollTo({
      left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
      top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
      behavior: 'smooth'
    });
  });
}



  /********************************/
 /**** VARIANT FORCE REDIRECT ****/
/********************************/
/**
 *  @class
 *  @function VariantRedirect
 */
class VariantRedirect {
  constructor() {
    this.container = document.querySelector('.variant-selects');
    if(!this.container) return;
    this.sectionId = this.container.dataset.section;
    this.currentVariantId = this.container.querySelector('#SelectedVariant-'+this.sectionId).dataset.variantId;
    this.form = this.container.closest('.product-information').querySelector('.product-form .form');

    let hasVariantRedirect = document.getElementById('VariantForceRedirect') ? true : false;
    //this.data = JSON.parse(document.getElementById('ProductData').textContent);
    this.data = window.ProductData;
    if(hasVariantRedirect) this.variantRedirectData = JSON.parse(document.getElementById('VariantForceRedirect').textContent);

    this.checkVariantRedirect(this.currentVariantId);
    //document.addEventListener('product:variant-change', this.checkVariantRedirect.bind(this));

    this.form.addEventListener('change', (event) => {
      let newVariant = this.form.querySelector('[name="id"]');
      this.checkVariantRedirect(newVariant.value);
    });
  }

  checkVariantRedirect(variantId) {
    if(!this.data) return;
    //this.selectedVariant = this.variantRedirectData.variants.find(variant => variant.id == variantId);
    this.selectedVariant = this.data.variants.find(variant => variant.id == variantId);
    //console.log("selectedVariant", this.selectedVariant.id);
    //this.url = this.selectedVariant['redirect_url'];
    this.url = this.selectedVariant.metafields.redirect_url;

    if(this.url == null || !this.url || this.url == '') return;
    window.location.href = this.url;
  }
}





  /********************************/
 /**** PRODUCT FORCE REDIRECT ****/
/********************************/
document.addEventListener("DOMContentLoaded", (event) => {
  if(document.getElementById('ProductRedirectUrl')) {
    const redirectUrl = document.getElementById('ProductRedirectUrl').value;
    if(redirectUrl) {
      let splitString = redirectUrl.split('/');
      // console.log("URL2", splitString[3] + splitString[4]);
      if(splitString) {
        window.location.href = "/"+splitString[3] +"/"+ splitString[4];
      }
    }
  }
});





  /**********************************************/
 /**** EASIFY CHANGE VARIANT ON SIZE SELECT ****/
/**********************************************/
// waitForElement('input[name="properties[• Pet measurements]"]', 7000)
// .then(function(el) {
//   let tpoOptionType, selectedSize, lastSize;
//   let sizes = [];

//   const easifySizeOptionsContainer = el.closest('.tpo_option-input-inner').nextElementSibling;
//   if(!easifySizeOptionsContainer) return;
//   sizesOption = document.querySelectorAll('input[name="Size"]');
//   if(!sizesOption) return;
//   sizesOption.forEach(size => sizes.push(size.value));
//   sizes.push("XL");
//   //console.log(sizes);
//   easifySizeOptionsContainer.querySelectorAll('button.tpo_option-type-selection').forEach( (button) => {
//     // tpoLabel = button.querySelector('.tpo_option_type_description').previousElementSibling;
//     //tpoLabel.innerHTML = tpoLabel.innerHTML.replace('&mdash;','<br>');
//     // tpoLabel.innerHTML = tpoLabel.innerHTML.replaceAll('—','<br>');
//     button.addEventListener('click', () => {
//       if(!button.querySelector('.tpo_option_type_description')) return;
//       tpoOptionType = button.querySelector('.tpo_option_type_description').textContent;

//       if(tpoOptionType.includes('|')) {
//         selectedSize = tpoOptionType.split('|');
//         lastSize = selectedSize.at(0).trim();
//         lastSize = lastSize.at(-1);
//       } else {
//         selectedSize = tpoOptionType.split(' ');
//         lastSize = selectedSize.at(-1).trim();
//       }

//       if(lastSize == "XL") lastSize = "L";
//       let found = sizes.find(size => size == lastSize);
//       // console.log("FOUND SIZE", found);
//       if(document.querySelector(`input[value="${found}"]`)) {
//         document.querySelector(`input[value="${found}"]`).click();
//       }
//       return;
//     });
//     return;
//   });
// })
// .catch(function(err) {
//   console.warn(err);
// });



	/**********************************************/
	/**** Easify | Replace all '—' with a <br> ****/
	/**********************************************/
waitForElement('.tpo_option-set-container', 10000)
.then(function(el){
  let buttons = el.querySelectorAll('.tpo_option-type-selection.below_value');
  buttons.forEach((button) => {
    //button.querySelector('.tpo_option_type_label_wrapper').innerHTML = button.querySelector('.tpo_option_type_label_wrapper').innerHTML.replaceAll('—','<br>');
    // if(!button.querySelector('.tpo_option_type_description.below_value')) return;
    button.innerHTML = button.innerHTML.replaceAll('—','<br>');
  });
})
.catch(function(err) {
  console.warn(err);
});




  /************************************************/
 /**** INJECT ALLOWFULLSCREEN TO VIMEO VIDEOS ****/
/************************************************/
waitForElements('iframe[src*="player.vimeo.com"]', 5000)
.then(function(el) {
  el.forEach((element) => {
    element.setAttribute('allow', 'picture-in-picture');
    element.setAttribute('allowfullscreen', '');
    element.setAttribute('webkitallowfullscreen', '');
    element.setAttribute('mozallowfullscreen', '');
  });
});






  /*****************************************************/
 /**** VITALS BACK IN STOCK BUTTON | VARIANT LEVEL ****/
/*****************************************************/
/**
 *  @class
 *  @function VitalsBackInStock
 */
class VitalsBackInStock {
  constructor() {
    if(!document.querySelector('.variant-selects')) return;
    this.container = document.querySelector('.variant-selects');
    this.sectionId = this.container.dataset.section;

    this.form = this.container.closest('.product-information').querySelector('.product-form .form');
    this.button = document.getElementById('vitals-back_in_stock');

    this.currentVariantId = this.container.querySelector('#SelectedVariant-'+this.sectionId).dataset.variantId;
    this.checkBackInStock(this.currentVariantId);

    this.data = window.ProductData;
    //console.log("DATA", this.data);

    this.form.addEventListener('change', (event) => {
      let newVariant = this.form.querySelector('[name="id"]');
      this.checkBackInStock(newVariant.value);
    });
  }

  checkBackInStock(variantId) {
    if(!this.data) return;
    this.selectedVariant = this.data.variants.find(variant => variant.id == variantId);
    let hideBackInStock = this.selectedVariant.metafields.hideBackInStock;
    if(this.button.innerHTML == "" || hideBackInStock == "") return;
    if(hideBackInStock) {
      this.button.removeAttribute("hidden");
    } else {
      this.button.setAttribute("hidden","");
    }
  }
}




  /*******************************************************/
 /**** OPEN OVERLAY WHEN AN ITEM IS ADDED TO THE CART ****/
/*******************************************************/
document.addEventListener("cart:item-added", function (evt) {
    OverlayManager.open(document.getElementById('CartDrawerContainer'));
    //document.getElementById('CartDrawerContainer').classList.add('active');
});





  /*************************************************************/
 /**** PRODUCT GALLERY THUMBNAILS SCROLL TO IMAGE ON HOVER ****/
/*************************************************************/
class ProductSliderThumbnails {
  constructor() {
    this.container = document.querySelector('.product-gallery-container #Product-Thumbnails');
    this.thumbnails = this.container.querySelectorAll('.product-thumbnail');
    this.productSlider = this.container.closest('.product-image-container').querySelector('#Product-Slider');
    this.flkty = new Flickity(this.productSlider);

    this.thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('hover', this.onHover.bind(this));
    });
  }

  onHover(evt) {
    
  }
}





  /********************************/
 /**** PRODUCT SLIDER CUSTOM *****/
/********************************/
class ProductSliderCustom {
  constructor() {
    this.productSlider = document.getElementById('Product-Slider');
    this.slider = this.productSlider.querySelector('.flickity-slider');
    this.form = this.productSlider.closest('.thb-product-detail.product').querySelector('.product-information .product-form .form');
    this.flkty = window.productGalleryFlickity;

    // ADD CUSTOM CSS PROPERTY OF THE SLIDER'S HEIGHT
    let viewPortHeight = this.productSlider.querySelector('.flickity-viewport').getBoundingClientRect().height + 'px';
    this.productSlider.querySelector('.flickity-viewport').style.setProperty('--flickity-viewport-height', viewPortHeight);

    this.assignDataIndexToActiveImages();
    this.flkty.on( 'staticClick', ( event, pointer, cellElement, cellIndex ) => this.assignDataIndexToActiveImages());
    document.addEventListener('product:variant-change', this.assignDataIndexToActiveImages.bind(this));
  }

  assignDataIndexToActiveImages() {
    //console.log("assignDataIndexToActiveImages");
    setTimeout(() => {
      this.slider = this.productSlider.querySelector('.flickity-slider');
      let ind = 0;
      this.slider.querySelectorAll('.product-images__slide.is-active').forEach( function(slide, index) {
        if(slide.querySelector('.product-single__media-zoom')) {
          slide.querySelector('.product-single__media-zoom').dataset.customIndex = ind;
          ind += 1;
        }
      });
    }, 1000);
  }
}



// FLICKITY VIEWPORT HEIGHT ON VARIANT CHANGE
document.addEventListener("product:variant-change", function (evt) {
  // ADD CUSTOM CSS PROPERTY OF THE SLIDER'S HEIGHT
  let productSlider = document.getElementById('Product-Slider');
  setTimeout(() => {
    let viewPortHeight = productSlider.querySelector('.flickity-viewport').getBoundingClientRect().height + 'px';
    productSlider.querySelector('.flickity-viewport').style.setProperty('--flickity-viewport-height', viewPortHeight);    
  }, 1000);
});



// CALL ALL CLASSES CREATED ABOVE IN ONE WINDOW LOAD EVENT LISTENER
document.addEventListener('DOMContentLoaded', (event) => {
  if(document.querySelector('.variant-selects')) {
    if (typeof VariantRedirect !== 'undefined') {
      new VariantRedirect();
    }
  }
  if(document.getElementById('vitals-back_in_stock')) {
    if(typeof VitalsBackInStock !== 'undefined') {
      new VitalsBackInStock();
    }
  }
  if(document.getElementById('Product-Thumbnails')) {
    if(typeof ProductSliderThumbnails !== 'undefined') {
      new ProductSliderThumbnails();
    }
  }
  if(document.getElementById('Product-Slider')) {
    if (typeof ProductSliderCustom !== 'undefined') {
      new ProductSliderCustom();
    }
  }
});